module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-4.807da863.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-4.png
// module id = 194
// module chunks = 0